import { LinearProgress, styled, Typography } from "@mui/material";

export const StyledCustomStepper = {
    ProgressContainer: styled("div")(({ theme }) => ({
        display: "flex",
        justifyContent: "space-evenly",
        margin: 25,
    })),
    LinearProgress: styled(LinearProgress)(({ theme }) => ({
        width: "85%",
        margin: 10,
    })),
    DisplayGrupos: styled(Typography)(({ theme }) => ({
        fontSize: 18,
    })),
}